import { render } from "./BillingRunStatus.vue?vue&type=template&id=55f3b605"
import script from "./BillingRunStatus.vue?vue&type=script&lang=js"
export * from "./BillingRunStatus.vue?vue&type=script&lang=js"

import "./BillingRunStatus.vue?vue&type=style&index=0&id=55f3b605&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__